import "core-js/modules/es.array.includes.js";
import styled from 'styled-components';
import DashedBox from 'components/DashedBox';
function getStatusColor(props) {
  if (props.isDragReject) {
    return props.theme.globals.colorBlocks.negative;
  }
  if (props.isDragActive) {
    return props.theme.text;
  }
  if (props.defaultTransparent) {
    return 'transparent';
  }
}
function getCursor(props) {
  if (props.isDragReject || props.isDisabled) {
    return 'not-allowed';
  }
  return 'pointer';
}
function shouldForwardProp(prop) {
  return !['isDragActive', 'isDragReject', 'defaultTransparent', 'isDisabled'].includes(prop);
}
export var DropIndicator = styled(DashedBox).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "DropIndicator",
  componentId: "sc-kn5rfj-0"
})(["border-color:", ";cursor:", ";", ""], function (p) {
  return getStatusColor(p);
}, function (p) {
  return getCursor(p);
}, function (p) {
  return p.isDisabled && "\n\t\t\tdisplay: none;\n\t\t";
});
export default DropIndicator;